import useLocalForage from "hooks/useLocalForage";
import React, { createContext, useCallback } from "react";

interface ISavedArticlesContext {
  links: string[];
  addLink?: (title: string) => void;
  removeLink?: (title: string) => void;
  clearLinks?: () => void;
}

export const SavedArticlesContext = createContext<ISavedArticlesContext>({
  links: [],
});

interface SavedArticlesContextProps {}

export const SavedArticlesContextProvider: React.FC<SavedArticlesContextProps> = ({
  children,
}) => {
  const [links, setLinks] = useLocalForage("savedLinks", []);

  const addLink = useCallback(
    newLink => {
      // save unique links
      setLinks([...new Set([...links, newLink])]);
    },
    [links, setLinks]
  );

  const removeLink = useCallback(
    target => {
      setLinks(links.filter(l => l !== target));
    },
    [links, setLinks]
  );

  const clearLinks = useCallback(() => setLinks([]), [setLinks]);

  return (
    <SavedArticlesContext.Provider
      value={{ links, addLink, removeLink, clearLinks }}
    >
      {children}
    </SavedArticlesContext.Provider>
  );
};

export default SavedArticlesContextProvider;
